import { pixelMask, TILE_SYMBOLS } from '@/utils/tilePixels';
import { colors } from '@/styles';
import { Signal } from '@/models/data/Signal';
import { TileType } from '@/models/TileTypes';
import {
  defaultTileGraphics,
  sideGraphics,
  connectionGraphics,
} from '@/models/tiles/DefaultTileGraphics';
import { TileDefinition, TileGraphicsDefinition } from '@/models/tiles/TileDefinition';
import { Side, TileSideIOType } from '@/schemas/tiles';
import { standardBuildAndConnect } from '@/models/logic/utils';

export const clockIoSides = {
  [Side.TOP]: { type: TileSideIOType.NONE, forceConnection: false },
  [Side.RIGHT]: { type: TileSideIOType.OUTPUT, forceConnection: true },
  [Side.BOTTOM]: { type: TileSideIOType.NONE, forceConnection: false },
  [Side.LEFT]: { type: TileSideIOType.INPUT, forceConnection: true },
};

export interface ClockTileState {
  intervalMs: number;
  interval: ReturnType<typeof setInterval> | null;
  state: Signal;
}

export class ClockTile implements TileDefinition<ClockTileState> {
  type = TileType.Clock;

  name = 'Clock';
  canRotate = true;

  createDefaultState = () => ({
    intervalMs: 1000,
    interval: null,
    state: Signal.LOW,
  });

  graphics = clockTileGraphicsDefinition;
  buildAndConnectNodes: NonNullable<
    TileDefinition<ClockTileState>['buildAndConnectNodes']
  > = (data) => {
    const queue = standardBuildAndConnect('CLOCK', data, this);
    const node = data.graph.nodes.get(data.instance.logicNodeIds![Side.TOP]!);
    const duration = (data.instance.state as ClockTileState).intervalMs;
    if (node)
      node.state.intervalMs = Number.isFinite(duration) && duration > 0 ? duration : 1000;
    return queue;
  };

  readonly ioSides = clockIoSides;
}

export const clockTileGraphicsDefinition: TileGraphicsDefinition<ClockTileState> = {
  type: TileType.Clock,
  draw: function (g, { meta, connections, context }): void {
    defaultTileGraphics(g);
    sideGraphics(g, clockIoSides, colors.signalColor, colors.noSignalColor, meta);
    connectionGraphics(
      g,
      colors.signalColor,
      colors.noSignalColor,
      meta,
      connections,
      clockIoSides,
      context,
    );

    const color =
      meta.outputs.right === Signal.HIGH ? colors.signalColor : colors.noSignalColor;

    pixelMask(g, TILE_SYMBOLS.clock, 5, 5, color);
  },
};
